module.exports = __webpack_public_path__ + "media/images/application/template/tick-c4ff8a7f211d29c6c809e038131d020c.png";